class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    // custom code
    if(event.target.querySelector(".icon-search") || event.target.classList.contains("icon-search")){
      this.setPopularSearchesLink();
    }

    // hiding sticky filter bar custom
    const stickyFilterBar = document.querySelector(".custom__position--sticky, .custom__searchpage-sticky-filter-bar");
    const stickyFilterBarSearchPage = document.querySelector(".custom__searchpage-sticky-filter-bar");
    if(stickyFilterBar){
      stickyFilterBar.style.visibility = "hidden";
    }
    if(stickyFilterBarSearchPage){
      stickyFilterBarSearchPage.style.visibility = "hidden";
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    // showing sticky filter bar custom
    const stickyFilterBar = document.querySelector(".custom__position--sticky");
    const stickyFilterBarSearchPage = document.querySelector(".custom__searchpage-sticky-filter-bar");
    if(stickyFilterBar){
      stickyFilterBar.style.visibility = "visible";
    }
    if(stickyFilterBarSearchPage){
      stickyFilterBarSearchPage.style.visibility = "visible";
    }
  }

 // for custom popular search queries
  setPopularSearchesLink () {
    const popularSearchItems = this.querySelectorAll("[data-ps-item]");
    popularSearchItems.forEach((itm) => (itm.href = createCustomSearchLink(itm.dataset.psQuery)));
  };
}

customElements.define('details-modal', DetailsModal);
